import styled from 'styled-components';
import { images } from '../../../../Constants/ImageUrls';

export const SectionImgWrapper = styled.div`
  position: relative;
  padding-top: ${(props) => props.imageRatioMobile || '100%'};
  @media (max-width: 720px) {
    .desktop_image {
      display: none !important;
    }
    .mobile_image {
      display: block !important;
    }
  }
  @media (min-width: 720px) {
    .mobile_image {
      display: none !important;
    }
    .desktop_image {
      display: block !important;
    }
  }
  @media (min-width: 720px) {
    padding-top: ${(props) => props.imageRatioDesktop || '100%'};
  }
  .bgImage {
    width: 100%;
  }
  img {
    background: url(${(props) =>
        props.placeholderImageMobile || images.defaultImage})
      center center no-repeat;
    background-size: cover;

    @media (min-width: 720px) {
      background: url(${(props) =>
          props.placeholderImageDesktop || images.defaultImage})
        center center no-repeat;
      background-size: cover;
    }
  }
`;
export const SectionTitle = styled.p`
  font-size: clamp(1em, 3vw, 1.3em);
  padding: 20px 10px 0px;
  color: #414141;
  position: relative;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 10px;
  letter-spacing: 1px;
  display: -webkit-box;
  width: 99%;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (min-width: 768px) {
    text-align: center;
    width: max-content;
  }
`;
export const ExploreBtnStyle = styled.button`
  margin: 6px auto 0px;
  border: solid 1px #ef4e5e;
  padding: 16px 0;
  font-size: 14px;
  letter-spacing: 1px;
  background: ${(props) => (props.showMore ? '#ef4e5e' : '#fff')};
  border-radius: 4px;
  color: ${(props) => (props.showMore ? '#fff' : '#ef4e5e')};
  font-weight: 600;
  display: flex;
  align-items: center;
  column-gap: 8px;
  border-radius: 8px;

  outline: none;
  width: ${(props) => (props.showMore ? '75%' : '96%')};
  font-family: Montserrat;
  overflow: hidden;
  position: relative;
  img {
    width: 16px;
    height: 16px;
  }
  .whiteArrow {
    display: none;
  }
  justify-content: center;
  span.ripple {
    position: absolute;
    border-radius: 50%;
    transform: scale(0);
    animation: ripple 600ms linear;
    background-color: ${(props) =>
      props.showMore ? 'rgba(255,255,255,0.3)' : 'hsl(0deg, 0%, 0%, 18%)'};
  }
  @keyframes ripple {
    to {
      transform: scale(4);
      opacity: 0;
    }
  }
  @media (min-width: 768px) {
    cursor: pointer;
  }
`;

export const BestSellerHeading = styled.h3`
  color: #535353;
  font-weight: 600;
  font-size: clamp(22px, 3vw, 32px);
  position: relative;
  width: max-content;
  margin: auto;
  margin-bottom: 10px;
  &:before {
    content: '';
    width: 40px;
    display: block;
    height: 1px;
    background-color: #ddd;
    top: 50%;
    transform: translate(-60px, -50%);
    position: absolute;
    @media (min-width: 768px) {
      width: 120px;
      transform: translate(-150px, -50%);
    }
  }
  &:after {
    content: '';
    width: 40px;
    display: block;
    height: 1px;
    background-color: #ddd;
    top: 50%;
    transform: translate(60px, -50%);
    position: absolute;
    @media (min-width: 768px) {
      width: 120px;
      transform: translate(150px, -50%);
    }
    right: 0;
  }
  @media (min-width: 768px) {
    margin: 24px auto 32px;
  }
`;
